import { useEffect, useState } from 'react';

import { formatEnvironmentTitle } from '@/helpers/formatEnvironmentTitle';
import { useEnvironment } from '@/providers/EnvironmentProvider';

export const useFormattedTitle = (defaultTitle: string) => {
	const { environmentString, isLoading } = useEnvironment();
	const [title, setTitle] = useState('');

	useEffect(() => {
		if (!isLoading) {
			setTitle(
				`${formatEnvironmentTitle(environmentString)}${defaultTitle}`,
			);
		}
	}, [environmentString, defaultTitle, isLoading]);

	return [title, environmentString];
};
